export default __webpack_public_path__ + "static/media/king-khaled-international-airport.a9708030.png";